'use client'

import Link from 'next/link'
import Container from '../(public-pages)/catalog/components/CatalogContainer'
import TechStack from './TechStack'
import OtherFeatures from './OtherFeatures'
import {
    HiShieldCheck,
    HiBuildingOffice2,
    HiTruck,
    HiPercentBadge,
} from 'react-icons/hi2'

export const metadata = {
    title: 'МаркетСИЗ — спецодежда и средства защиты',
    description:
        'Интернет-магазин спецодежды, рабочей обуви и СИЗ. Большой выбор, доставка по всей России.',
    openGraph: {
        title: 'МаркетСИЗ — спецодежда и СИЗ',
        description:
            'Качественная спецодежда, рабочая одежда, обувь и средства индивидуальной защиты. Опт и розница с доставкой.',
        url: 'https://marketsiz.ru',
        siteName: 'МаркетСИЗ',
        locale: 'ru_RU',
        type: 'website',
    },
      other: {
    author: 'МаркетСИЗ',
    publisher: 'МаркетСИЗ',
  },
}

export default function HomePage() {
    return (
        <main className=" text-gray-800">
       
                    <Container className=' py-16 px-6 lg:py-24 lg:px-16 '>                
                        <div className="bg-white dark:bg-gray-900 rounded-3xl px-4 py-4 md:py-12 lg:px-16  lg:py-16 shadow-md hover:shadow-xl transition-shadow relative overflow-hidden">
                            <h1 className="text-xl lg:text-4xl font-bold mb-6 text-gray-900 dark:text-white">
                                Интернет-магазин спецодежды и СИЗ — МаркетСИЗ
                            </h1>
                            {/* <h2 className="text-sm md:text-lg leading-relaxed text-gray-700 dark:text-gray-300 mb-3"> Купить оптом спецодежду и средства индивидуальной защиты для предприятий</h2> */}

                            <p className="text-sm md:text-lg leading-relaxed text-gray-700 dark:text-gray-300 mb-3">
                                У нас вы найдете широкий ассортимент рабочей
                                одежды, обуви и СИЗ для различных сфер. Мы
                                сотрудничаем только с проверенными поставщиками,
                                чтобы гарантировать надежность каждой модели.
                            </p>
                            <p className="text-sm md:text-lg leading-relaxed text-gray-700 dark:text-gray-300">
                                Компания МаркетСИЗ специализируется на
                                комплексном снабжении предприятий. В нашем
                                магазине вы можете приобрести спецодежду от
                                ведущих российских и зарубежных производителей,
                                а также все необходимые средства индивидуальной
                                защиты для различных работ. Наши менеджеры
                                помогут подобрать СИЗ под ваши потребности.
                            </p>
                        </div>
                    </Container>
                        {/* Преимущества */}

                         <section className=" bg-gray-800 dark:bg-gray-800 py-16 px-6 lg:py-24 lg:px-16 overflow-hidden">
                        <h2 className="text-xl lg:text-4xl text-center mb-6 text-white">
                            Почему выбирают МаркетСИЗ
                        </h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">
                            <div className="flex items-start bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow gap-4">
                                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 text-gray-800 rounded-full flex items-center justify-center text-xl">
                                    <HiShieldCheck size={24} />
                                </div>

                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                        Надежность и безопасность
                                    </h3>
                                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Вся спецодежда соответствует стандартам
                                        ГОСТ и рассчитана на активное
                                        использование.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow gap-4">
                                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 text-gray-800 rounded-full flex items-center justify-center text-xl">
                                    <HiBuildingOffice2 size={24} />
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                        Для организаций и частных клиентов
                                    </h3>
                                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Мы работаем с розничными и
                                        корпоративными покупателями. Для
                                        компаний доступны индивидуальные
                                        условия, брендирование и консультации.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow gap-4">
                                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 text-gray-800 rounded-full flex items-center justify-center text-xl">
                                    <HiTruck size={24} />
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                        Доставка по всей России
                                    </h3>
                                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Быстрая и надёжная доставка по всей
                                        стране для всех заказов, независимо от
                                        объема.
                                    </p>
                                </div>
                            </div>

                            <div className="flex items-start bg-white dark:bg-gray-900 rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow gap-4">
                                <div className="flex-shrink-0 w-12 h-12 bg-primary/20 text-gray-800 rounded-full flex items-center justify-center text-xl">
                                    <HiPercentBadge size={24} />
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                                        Выгодные цены и акции
                                    </h3>
                                    <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                                        Мы предлагаем конкурентные цены, скидки
                                        и специальные предложения для постоянных
                                        клиентов.
                                    </p>
                                </div>
                            </div>
                        </div>
                        </section>
                  
          


            <TechStack />

            <OtherFeatures />

            {/* <div className="flex justify-center mb-10">
                    <Link
                        href="/catalog"
                        className="inline-flex items-center justify-center mr-2 bg-pimary-hover text-white hover:text-white font-semibold rounded-xl h-14 px-8 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-base"
                    >
                        Перейти в каталог
                    </Link>
                </div> */}
            <div className="relative overflow-hidden min-h-[100px] text-center border-b border-white/10">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: "url('/image/landing/for-home.webp')",
                    }}
                />
                <div className="absolute inset-0 bg-gradient-to-r from-primary to-transparent" />

                <Container className="relative container py-16 lg:py-24">
                    <Link
                        href="/catalog"
                        className="inline-flex items-center justify-center bg-second text-white font-semibold rounded-xl h-14 px-10 shadow-lg hover:scale-105 transition text-base"
                    >
                        Перейти в каталог
                    </Link>
                </Container>
            </div>
        </main>
    )
}
